module.exports = __webpack_public_path__ + "img/Artify_Dark.05ff0492.png";